import { ScrollablePane, Sticky } from "@fluentui/react";
import { isNil } from "lodash";
import * as React from "react";
import { FunctionComponent, useContext, useEffect, useState } from "react";
import { UserContext } from "../../Auth";
import { Location } from "@graphql";
import LocationCard from "../../shared/location/location-card/LocationCard";
import BackHeader from "../shared/back-header/BackHeader";

interface Props {
  selectedLocationId?: string;
  onChange?: (location: Location) => void;
  onBackClick: () => void;
  allLocations: Location[];
}

const Locations: FunctionComponent<Props> = (props: Props) => {
  const { onChange, selectedLocationId, onBackClick, allLocations } = props;
  const user = useContext(UserContext);
  const [locations, setLocations] = useState<Location[]>();

  useEffect(() => {
    if (isNil(user)) {
      return undefined;
    }
    setLocations(allLocations);
  }, [selectedLocationId, user]);

  const onLocationClick = (id: string) => {
    onChange(locations.find((s) => s._id === id));
  };

  const onRenderCell = (item: Location, index: number | undefined) => {
    return (
      <LocationCard
        key={`locationCard-${index}`}
        index={index}
        location={item}
        onLocationClick={onLocationClick}
        isActive={item._id === selectedLocationId}
      />
    );
  };

  return (
    <ScrollablePane style={{ backgroundColor: "white" }}>
      <Sticky>
        <BackHeader title={"Locations"} onBackClick={onBackClick} />
      </Sticky>
      {locations && locations.length > 0 && locations.map((location, index) => onRenderCell(location, index))}
    </ScrollablePane>
  );
};

export default Locations;
